import styled from 'styled-components';

export const Icon = styled.span`
display:flex;
`